import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

/**
 * @description Default error for authentication
 */
export class AuthenticationError extends CedeSDKError {
  constructor(code = SdkErrorCodes.AUTHENTICATION_ERROR, message = SdkErrorMessages.AUTHENTICATION_ERROR) {
    super(code, message);
    this.name = "AuthenticationError";
  }
}

/**
 * @description Thrown when the credentials are invalid
 */
export class InvalidCredentialsError extends AuthenticationError {
  constructor() {
    super(SdkErrorCodes.INVALID_CREDENTIALS, SdkErrorMessages.INVALID_CREDENTIALS);
    this.name = "InvalidCredentialsError";
    this.notReportable = true;
  }
}

/**
 * @description Thrown when the authentication flow is not supported
 */
export class AuthenticationFlowNotSupportedError extends AuthenticationError {
  constructor() {
    super(SdkErrorCodes.AUTHENTICATION_FLOW_NOT_SUPPORTED, SdkErrorMessages.AUTHENTICATION_FLOW_NOT_SUPPORTED);
    this.name = "AuthenticationFlowNotSupportedError";
  }
}
/**
 * @descrion Thrown when the oauth credentials are revoked
 */
export class OAuthAccessRevokedError extends AuthenticationError {
  constructor() {
    super(SdkErrorCodes.OAUTH_ACCESS_REVOKED, SdkErrorMessages.OAUTH_ACCESS_REVOKED);
    this.name = "OAuthAccessRevokedError";
    this.notReportable = true;
  }
}

/**
 * @description Thrown when Hotstuff rejects an `/exchange` action because the
 * master wallet has not completed onboarding with a referral code. The only
 * way forward is for the user to sign up on Hotstuff with a referral code and
 * retry — no automatic retry / reconnect can recover this.
 *
 */
export class ReferralRequiredError extends AuthenticationError {
  constructor() {
    super(SdkErrorCodes.REFERRAL_REQUIRED, SdkErrorMessages.REFERRAL_REQUIRED);
    this.name = "ReferralRequiredError";
    this.notReportable = true;
  }
}

/**
 * @description Thrown when the exchange rejects a signed action because the
 * agent/API wallet that produced the signature is not registered as an
 * approved signer for the master account (e.g. Hotstuff `"invalid order signer"`,
 * Hyperliquid `"API Wallet ... does not exist"`, Paradex `"Subkey not found"`).
 * The only recovery is for the user to re-run the agent approval flow.
 */
export class AgentWalletNotFoundError extends AuthenticationError {
  constructor() {
    super(SdkErrorCodes.AGENT_WALLET_NOT_FOUND, SdkErrorMessages.AGENT_WALLET_NOT_FOUND);
    this.name = "AgentWalletNotFoundError";
    this.notReportable = true;
  }
}
